import { ofType } from 'redux-observable';
import { filter, withLatestFrom, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { BasketType } from 'src/queries/__global_generated__/globalTypes';

import { CustomerInfo, isCustomerInfo } from './types';

/**
 * When Guests are using home delivery, we need to use the
 * shipping address events to trigger the start checkout event.
 */
export function guestHomeDeliveryEpic(action$, state$): Observable<CustomerInfo> {
    return action$.pipe(
        ofType('Checkout.SetShippingAddress'),

        withLatestFrom(state$),

        // Only trigger when the user is not logged in and using home delivery.
        filter(
            ([, state]) =>
                state.user?.session !== 'SignedIn' && state.cart?.raw?.woodies?.basket_type === BasketType.DELIVERY,
        ),

        map(([, state]: [unknown, any]) => {
            const checkout = state.checkout ?? {};

            const email = checkout.shippingAddress?.email;
            const firstName = checkout.shippingAddress?.firstname ?? undefined;
            const lastName = checkout.shippingAddress?.lastname ?? undefined;

            if (email && firstName && lastName) {
                const customerInfo: CustomerInfo = {
                    email,
                    firstName,
                    isGuest: true,
                    lastName,
                };

                return customerInfo;
            }

            return null;
        }),

        // Filter out null values
        filter(isCustomerInfo),
    );
}
